<template>
  <el-dialog v-dialogDrag title="选择系统角色" :visible.sync="dlgVisible" width="500px">
    <el-form ref="togetherCurrentForm" size="small">
      <el-form-item label="复制结果">
        <el-radio-group v-model="syncType">
          <el-radio :label="1">合并</el-radio>
          <el-radio :label="0">覆盖</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="height: 400px; overflow-y: scroll;">
      <SpecRole :userList="[]" @updateRight="selectedRoleChanged"></SpecRole>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dlgVisible = false">取 消</el-button>
      <el-button v-preventReClick :loading="submiting" type="primary" size="small" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SpecRole from '@/CommonDP/components/chooseMember/component/SpecRole.vue';
import priviService from '@/CommonDP/service/privi-service';
export default {
  components: { SpecRole },

  data() {
    return {
      dlgVisible: false,
      fromRoleId: "",
      submiting: false,
      selectedRoleIds: [],
      syncType: 1
    };
  },

  methods: {
    showDlg(fromRoleId) {
      this.syncType = 1;
      this.fromRoleId = fromRoleId;
      this.dlgVisible = true;
    },
    selectedRoleChanged(type, roleList) {
      console.debug("type=", type, "roleList=", roleList);
      this.selectedRoleIds = roleList.map(item => item.roleID || item.roleId);
    },

    async submit() {
      if (!this.selectedRoleIds.length) {
        this.$error("请勾选目标角色");
        return;
      }
      try {
        this.submiting = true;
        console.debug("准备提交数据：", this.selectedRoleIds);
        const json = { fromRoleId: this.fromRoleId, toRoleIds: this.selectedRoleIds, syncType: this.syncType };
        await priviService.copyPermissionsFromRoleToOthers(json);
        this.$success("操作成功");
        this.dlgVisible = false;
      } finally {
        this.submiting = false;
      }
    }
  }

};
</script>

<style></style>
